// axios
import axios from 'axios'

// const baseURL = ""

/* export default axios.create({
  baseURL: baseURL
  // You can add your headers here
}) */

export const fetchData = async (method = '', url = '', data = '', headers = {
  'Content-Type': 'application/json'
}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: data,
      headers: headers
    }).then(function (response) {
      resolve(response)
    })
      .catch(function (err) {
        reject(err)
      }).finally(() => {
      })
  })
}

export default axios
